import { reactive } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { paramsService } from '@/services/parametros.services'

import type { bannerType } from '@/stores/model/config'
import type { Carousel, CustomButton } from '@/views/configuracao/personalizar/components/login/types'

export const useParams = createGlobalState(() => {
  const logoFiles = {
    icon: null as File | null,
    menu: null as File | null,
    loginLight: null as File | null,
    loginDark: null as File | null
  }

  const originalParams = {
    banners: {
      active: true,
      items: [] as bannerType[]
    },
    general: {},
    logos: {
      menu: '',
      loginLight: '',
      loginDark: '',
      icon: ''
    },
    login: {
      align: 'right' as 'left' | 'center' | 'right',
      carousels: [] as Carousel[],
      customButton: {
        active: false,
        label: '',
        redirectUrl: '',
        newTab: false,
        outline: false
      } as CustomButton
    },
    colors: {
      images: {
        primary: {
          light: '#c191ff',
          dark: '#c191ff',
          useDark: false
        },
        secondary: {
          useCustom: false,
          default: '#a3a3a3',
          light: '#3cdfad',
          dark: '#3cdfad',
          useDark: false
        }
      },
      interface: {
        primary: '#c191ff',
        textColor: '#ffffff',
        autoFontColor: true
      }
    },
    theme: {
      defaultTheme: 'DefinidoPeloUsuario' as 'Claro' | 'Escuro' | 'DefinidoPeloUsuario',
      initialTheme: null as 'Claro' | 'Escuro' | null
    }
  }

  const batchMode = reactive({
    active: false,
    settings: {
      banners: false,
      logos: false,
      colors: false,
      login: false,
      theme: false
    },
    parameters: { ...originalParams }
  })

  const originalSettings = JSON.parse(JSON.stringify(batchMode.settings))
  const originalParameters = JSON.parse(JSON.stringify(batchMode.parameters))

  return {
    batchMode,
    resetParams: () => {
      Object.assign(batchMode.settings, JSON.parse(JSON.stringify(originalSettings)))
      Object.assign(batchMode.parameters, JSON.parse(JSON.stringify(originalParameters)))
    },
    changedParams: () => {
      return JSON.stringify(batchMode.parameters) !== JSON.stringify(originalParams)
    },
    logos: {
      setFile: (type: keyof typeof logoFiles, file: File) => {
        logoFiles[type] = file
      },
      removeFile: (type: keyof typeof logoFiles) => {
        logoFiles[type] = null
      },
      clearFiles: () => {
        Object.keys(logoFiles).forEach((key) => {
          logoFiles[key] = null
        })
      },
      upload() {
        const uploadsStatus = [] as Promise<void>[]

        // Verifica a necessidade de upload de Logos
        Object.keys(logoFiles).forEach((key) => {
          if (!logoFiles[key]) return

          uploadsStatus.push(paramsService.uploadFile(logoFiles[key])
            .then(({ data: url }) => {
              batchMode.parameters.logos[key] = url
            }))
        })

        return Promise.all(uploadsStatus)
      }
    }
  }
})
